import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgSwitchArrow = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="26"
        width="28"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 28 26"
    >
        <path
            d="M3.52352 5.60303H5.46595L2.5523 20.3759H0.609863L3.52352 5.60303Z"
            fill="#FED05D"
        />
        <path
            d="M6.15779 5.60303H8.10023L5.18658 20.3759H3.24414L6.15779 5.60303Z"
            fill="#FED05D"
        />
        <path
            d="M8.88457 5.60303H14.8969L11.8907 20.3759H5.87842L8.88457 5.60303Z"
            fill="#5F56C6"
        />
        <path
            clipRule="evenodd"
            d="M21.3413 1.03628C21.1368 0.590301 20.4793 0.674843 20.3943 1.15803L19.6139 5.59586L15.6669 5.5703L12.6753 20.3752H17.0148L16.2599 24.6672C16.1747 25.1519 16.7673 25.4552 17.1106 25.1026L27.2492 14.6911C27.3933 14.5431 27.4316 14.3217 27.3455 14.1339L21.3413 1.03628Z"
            fill="#715AFF"
            fillRule="evenodd"
        />
    </svg>
);

export const SwitchArrowIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgSwitchArrow}
        fontSize={fontSize}
    />
);
